<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M16.7529 10C16.7529 12.4853 14.7382 14.5 12.2529 14.5C9.76765 14.5 7.75293 12.4853 7.75293 10C7.75293 7.51472 9.76765 5.5 12.2529 5.5C14.7382 5.5 16.7529 7.51472 16.7529 10Z"
    :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.25293 10H4.75293" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.25293 6.25H5.50293" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.25293 13.75H5.50293" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.625 13.375L17.5 15.25" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'SearchBrandIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>
